<template>
  <button @click="onClick" :disabled="disabled" class="custom-button">
    <slot></slot>
    <!-- Default slot to allow dynamic button text -->
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event)
    },
  },
}
</script>

<style scoped>
.custom-button {
  width: 100%;
  height: 46.681px;
  flex-shrink: 0;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background: var(--primary-color);
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s;
}

.custom-button:hover {
  background-color: var(--primary-color); /* Slightly darker shade on hover */
}

.custom-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
</style>
